import { render } from "./SuperAdminLayout.vue?vue&type=template&id=17bfd9f0&scoped=true"
import script from "./SuperAdminLayout.vue?vue&type=script&lang=js"
export * from "./SuperAdminLayout.vue?vue&type=script&lang=js"

import "./SuperAdminLayout.vue?vue&type=style&index=0&id=17bfd9f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bfd9f0"]])

export default __exports__